import ImageUrlProcurerInterface from "./ImageUrlProcurerInterface.js";

class ImageUrlProcurer extends ImageUrlProcurerInterface {
    constructor(envStorageValueGetter, imageCodeConfigStorage, getter) {
        super();
        this.envStorageValueGetter = envStorageValueGetter;
        this.imageCodeConfigStorage = imageCodeConfigStorage;
            /*
                imageCodeConfigStorage example
                    storage.set("cb_logo", {
                        url_base_env_key: "cisobot_images_url_base",
                        path: "/i/something.png"
                    }) 
            */
        this.getter = getter;
    }

    procure = (imageCode) => {
        // get the config for the image code
        const imageCodeConfig = this.getter.safeGet(() => this.imageCodeConfigStorage.get(imageCode), undefined);
        if (typeof imageCodeConfig === undefined) return undefined;
        const { url_base_env_key, path } = imageCodeConfig;

        // get the url base without trailing slash
        let safeUrlBase = this.getter.safeGet(() => this.envStorageValueGetter.get(url_base_env_key), "");
        if (safeUrlBase.endsWith("/") === true) {
            safeUrlBase = safeUrlBase.slice(0, -1);
        }

        // get the path with a leading slash
        let safePath = path;
        if (safePath.startsWith("/") === false) {
            safePath = `/${safePath}`;
        }

        const imageUrl = safeUrlBase + safePath;
        return imageUrl;
    }
}

export default ImageUrlProcurer;